import Dexie from "dexie";

import global from "../global.js";

const ModuleConfiguration = function(name, computed_configuration) {
    var default_configuration;
    if (name in global.default_configuration) {
        default_configuration = global.default_configuration[name];
    } else {
        default_configuration = {};
    }
    var configuration = Dexie.deepClone(default_configuration);
    var context = null;
    this.init = async (new_context) => {
        let old_context = context;
        if (new_context === old_context) {
            return;
        }
        context = new_context;
    };
    this.deinit = async () => {
        context = null;
    };
    this.set = (path, value) => {
        Dexie.setByKeyPath(configuration, path, value);
        return value;
    };
    this.get = (path) => {
        if (configuration === undefined) {
            return;
        }
        let value = Dexie.getByKeyPath(configuration, path);
        if (typeof value !== "undefined") {
            return value;
        }
        value = Dexie.getByKeyPath(computed_configuration, path);
        if (typeof value === "function") {
            return value(configuration, default_configuration);
        }
    };
    this.reset = () => {
        configuration = Dexie.deepClone(default_configuration);
    };
    this.apply = (modifications) => {
        for (let key in modifications) {
            if (!key.startsWith("data.")) {
                continue;
            }
            let path = key.substr("data.".length);
            this.set(path, modifications[key]);
        }
    };
    this.load = async (current_configuration) => {
        if (context === null){
            return;
        }
        if (current_configuration === undefined) {
            current_configuration = await context.configuration_retrieve({name});
        }
        if (current_configuration !== undefined) {
            configuration = Dexie.deepClone(current_configuration.data);
        }
        return configuration;
    };
    this.save = async () => {
        if (context === null){
            return;
        }
        var current_configuration = await context.configuration_retrieve({name});
        if (current_configuration === undefined) {
            current_configuration = await context.configuration_create({name, data: configuration});
        } else {
            current_configuration = await context.configuration_update({name, data: configuration});
        }
        configuration = Dexie.deepClone(current_configuration.data);
        return configuration;
    };
};
ModuleConfiguration.prototype.has_data_in = (modifications) => {
    return (Object.keys(modifications).find(key => /^data/.test(key)) !== undefined);
};

export default ModuleConfiguration;
